export const DEFAULT_TRACKING_EVENT: string = 'track_tab';
export const COMSCORE_TRACKING_EVENT: string = 'comscore_track';
export const PAGEVIEW_CANDIDATE_PATH: string = '/resources/xml/pvc.xml';
export const COMSCORE_TRACKING_TAB: string = 'ftbl__tab-item--';
export const MATCH_LINEUPS_FIELDS_WIDGET_TRACKING_KEY = 'formazioni_widget_available';
export const MATCH_FOLLOW_CTA_TRACKING_EVENT: string = 'cta_segui_partita_open';

// Already TRACKED TABS for comscoreTrack()
const tabsTracked: String[] = [];

export const analyticsTrack = async (
  key: string = DEFAULT_TRACKING_EVENT,
  value?: string | object,
  delay: number = 1000, // Only for JEST TESTING!
  iterations: number = 10 // Only for JEST TESTING!
): Promise<boolean> => {
  /**
   * ANALYTICS TRACKING relays on the presence of external "_satellite()" function
   * Loaded from CDN https://assets.adobedtm.com/launch-EN578e54a3f0c6478aa41c89022e30863c.min.js inside DIV ID "dtm_script"
   * TS doesn't know of its existence, so...
   */

  // eslint-disable-next-line no-console
  console.log('[analytics-track.ts] LMP analyticsTrack', { key, value });
  // @ts-ignore for _satellite.track() (loaded from external lib inside AEM template)

  const satellite = window._satellite;
  const fn: Function = () => {
    if (!value) {
      satellite.track(key);
      return;
    }
    if (typeof value === 'string') {
      satellite.track(key, { value });
      return;
    }
    satellite.track(key, value as Record<string, string | number | boolean>);
  };
  return setTimedInterval(fn, `'key=${key}, value=${JSON.stringify(value)}'`);
};

export const setTimedInterval = async (
  callback: Function,
  message?: string,
  delay: number = 1000,
  iterations: number = 10
): Promise<boolean> => {
  return new Promise(async (resolve, reject) => {
    let x = 0;
    const intervalID = setInterval(async () => {
      try {
        await callback();
        clearInterval(intervalID);
        // console.log(`[analytics-track.ts] LMP OK - Interval ${intervalID} cleared`);
        resolve(true);
      } catch (err) {
        // Surrender after all failed attempts
        if (++x >= iterations) {
          // eslint-disable-next-line no-console
          console.error(
            `[analytics-track.ts] LMP Function${
              message ? ` called with params ${message}` : ''
            } returned error after ${iterations} tries!`,
            err.toString()
          );
          clearInterval(intervalID);
          // console.log(`[analytics-track.ts] LMP KO - Interval ${intervalID} cleared`);
          reject(new Error(`Function${message ? ` called with params ${message}` : ''} not found!`));
        } else if (x === 1) {
          // eslint-disable-next-line no-console
          console.warn(
            `[analytics-track.ts] LMP Called function${
              message ? ` with params ${message}` : ''
            } returned error, will try again in ${delay / 1000} seconds for another ${iterations - x} times...`
          ); // One WARNING only, to avoid polluting the console...
        }
      }
    }, delay);
  });
};

export const getFetchRequestInit = (): RequestInit => {
  // Avoid CACHE when retrieving file '/resources/xml/pvc.xml' using FETCH
  const headers: HeadersInit = new Headers();
  headers.append('pragma', 'no-cache');
  headers.append('cache-control', 'no-store');
  headers.append('cache-control', 'max-age=0');

  return {
    method: 'GET',
    headers,
  };
};

export const comscoreTrack = async (id: String) => {
  const COMSCORE_TRACKING_URL: string = location
    ? new URL(`${location.origin}${PAGEVIEW_CANDIDATE_PATH}`).toString()
    : `https://sport.sky.it${PAGEVIEW_CANDIDATE_PATH}`;
  const COMSCORE_TRACKING_ID: string = `${COMSCORE_TRACKING_TAB}${id}`;

  if (tabsTracked.filter((tab: String) => tab === COMSCORE_TRACKING_ID).length === 0) {
    // Add TAB to ALREADY TRACKED array
    tabsTracked.push(COMSCORE_TRACKING_ID);

    // Calls _SATELLITE()
    analyticsTrack(COMSCORE_TRACKING_EVENT)
      .then((value) => console.log('[analytics-track.ts]', COMSCORE_TRACKING_EVENT, value)) // eslint-disable-line no-console
      .catch((err) => console.warn('[analytics-track.ts]', COMSCORE_TRACKING_EVENT, err)); // eslint-disable-line no-console

    // FETCH PVC.XML (we are NOT interested in getting the PAYLOAD, only the FETCH STATUS!)
    try {
      const response: Response = await fetch(new Request(COMSCORE_TRACKING_URL), getFetchRequestInit());
      if (response.status !== 200) {
        throw new Error(`FETCH - Status code is ${response.status}`);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('[analytics-track.ts] COMSCORE_TRACKING_URL not found.', {
        error,
        COMSCORE_TRACKING_URL,
      });
    }
  }
};

const trackDigitalData = (menu: HTMLElement | null): any => {
  const satelliteTrack = { interaction_name: 'playerpages-dropdown-selected' };
  analyticsTrack('generic_interaction', satelliteTrack)
    .then((value) => console.log('[analytics-track.ts]', 'generic_interaction', value)) // eslint-disable-line no-console
    .catch((err) => console.warn('[analytics-track.ts]', 'generic_interaction', err)); // eslint-disable-line no-console
};

const tabAddClickListener = (item: HTMLElement, parent: HTMLElement | null): void => {
  item.addEventListener('click', (e) => {
    trackDigitalData(parent);
  });
};

export const trackPageViews = (): void => {
  const playerPagesDropdown: HTMLElement | null = document.querySelector(
    'div[data-analytics-element] > div.ftbl__menu-list__menu'
  );

  if (playerPagesDropdown) {
    const dropdownItems: HTMLCollection = playerPagesDropdown.children;
    Array.from(dropdownItems).forEach((tab: HTMLElement) => tabAddClickListener(tab, playerPagesDropdown));
  }
};
